<div class="form-horizontal" [formGroup]="plantHandlingInstructions">
  <div class="form-group" [class.has-error]="lighting.invalid">
    <label class="control-label col-sm-2">Lighting</label>
    <span class="col-sm-10">
      <select formControlName="lighting" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of options.lightingInstructions" [ngValue]="option.id">{{ option.display }}</option>
      </select>
    </span>
  </div>

  <div class="form-group" [class.has-error]="temperature.invalid">
    <label class="control-label col-sm-2">Temperature</label>
    <span class="col-sm-10">
      <select formControlName="temperature" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of options.temperatureInstructions" [ngValue]="option.id">{{ option.display }}</option>
        </select>
    </span>
  </div>

  <div class="form-group" [class.has-error]="humidity.invalid">
    <label class="control-label col-sm-2">Humidity</label>
    <span class="col-sm-10">
      <select formControlName="humidity" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of options.humidityInstructions" [ngValue]="option.id">{{ option.display }}</option>
      </select>
    </span>
  </div>

  <div class="form-group" [class.has-error]="imagingNeeded.invalid">
    <label class="control-label col-sm-2">Imaging Needed?</label>
    <span class="col-sm-9">
      <ui-switch formControlName="imagingNeeded" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
    </span> 
  </div>

</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/plant-handling-instructions/plant-handling-instructions-form/plant-handling-instructions-form.component.html